import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	isLoading: false,
	leadResponse: {},
	leads: [],
	selectedLead: {},
};

const studentLead = createSlice({
	name: "studentLead",
	initialState,
	reducers: {
		isPending: state => {
			state.isLoading = true;
		},
		leadResponseSuccess: (state, { payload }) => {
			state.isLoading = false;
			state.leadResponse = payload;
		},
		getLeadsSuccess: (state, { payload }) => {
			state.isLoading = false;
			state.leads = payload;
		},
		getSelectedLead: (state, { payload }) => {
			state.isLoading = false;
			state.selectedLead = payload;
		},
		leadFail: (state, { payload }) => {
			state.isLoading = false;
			state.leadResponse = payload || {};
		},
	},
});

const { reducer, actions } = studentLead;

export const {
	leadResponseSuccess,
	getLeadsSuccess,
	getSelectedLead,
	leadFail,
	isPending,
} = actions;

export default reducer;
